/**
 * @fileoverview Empty state component for projects list
 */

import { memo } from 'react'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IconFolderOff } from '@tabler/icons-react'
import { Box, EmptyStateBox } from 'components'

interface EmptyStateProps {
  isLibrary?: boolean
}

/**
 * Displays empty state when no projects are found.
 * Shows different message for library vs my projects.
 */
export const EmptyState: FC<EmptyStateProps> = memo(({ isLibrary = false }) => {
  const { t } = useTranslation()

  const messageKey = isLibrary
    ? 'arc_projects.empty_library'
    : 'arc_projects.empty_projects'

  return (
    <Box mt="xl" py="xl">
      <EmptyStateBox
        withBorder
        icon={<IconFolderOff size={48} stroke={1.5} color="gray" />}
        text={t(messageKey)}
        textSize="md"
      />
    </Box>
  )
})

EmptyState.displayName = 'EmptyState'
